import type React from 'react';

import { ButtonSwitch, ButtonSwitchGroup } from '@vlabs/uikit';

import { useDepartmentListListContext } from './context';
import type { DepartmentListListMode } from './context';
import { useDepartmentListListTranslation } from './i18n';

function DepartmentListListModeSwitch(): React.JSX.Element {
  const { t } = useDepartmentListListTranslation();
  const { mode, setMode } = useDepartmentListListContext();

  return (
    <ButtonSwitchGroup<DepartmentListListMode>
      onChange={setMode}
      size="small"
      value={mode}
      variant="square"
    >
      <ButtonSwitch value="ownership">
        {t('mode_ownership')}
      </ButtonSwitch>
      <ButtonSwitch value="view">
        {t('mode_view')}
      </ButtonSwitch>
    </ButtonSwitchGroup>
  );
}

export { DepartmentListListModeSwitch };
